import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import NameWithTooltip from "../NameWithTooltip";
import { RegularHeaderProps } from "./types";

export const RegularHeader = ({
    titleValue,
    subtitleName,
    subtitleValue,
    additionalSubtitleName,
    additionalSubtitleValue
}: RegularHeaderProps) => {
    const { gray900, textPlaceholder } = colors;

    return (
        <div
            css={css({
                marginRight: "60px",
                marginBottom: "16px"
            })}
        >
            <div
                css={css({
                    color: gray900,
                    fontWeight: "500",
                    marginBottom: "4px"
                })}
            >
                <NameWithTooltip name={titleValue} lineH={32} fontSize={24} />
            </div>

            <div
                css={css({
                    display: "flex",
                    columnGap: "16px",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    fontWeight: "500",
                    marginTop: "4px",
                    overflowX: "hidden",

                    "& > div": {
                        display: "flex",
                        minWidth: 0,
                        overflowX: "hidden",

                        span: {
                            whiteSpace: "nowrap"
                        },

                        "span:first-of-type": {
                            color: textPlaceholder,
                            marginRight: "5px",
                            flexShrink: 0
                        },

                        "span:last-of-type": {
                            color: gray900,
                            flex: "1",
                            minWidth: 0,
                            whiteSpace: "nowrap",
                            overflowX: "hidden",
                            textOverflow: "ellipsis"
                        }
                    },

                    "@media (max-width: 839px)": {
                        flexDirection: "column",
                        alignItems: "flex-start",

                        "& > div": {
                            width: "100%"
                        }
                    }
                })}
            >
                <div>
                    <span>{subtitleName}:</span>
                    <span>{subtitleValue}</span>
                </div>

                {additionalSubtitleName && additionalSubtitleValue && (
                    <div>
                        <span>{additionalSubtitleName}:</span>
                        <span>{additionalSubtitleValue}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RegularHeader;
